export function formataCpfCnpj(cpfCnpj) {
  if (cpfCnpj.length === 11) {
    return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export function formatDate(date) {
  if (date === null) return
  if (date.length === 0) return
  const [anoIni, mesIni, diaIni] = date.split('T')[0].split('-')
  return `${diaIni}/${mesIni}/${anoIni}`
}

export function formatDateTime(date) {
  if (date === null) return
  if (date.length === 0) return
  const [anoIni, mesIni, diaIni] = date.split('T')[0].split('-')
  const [hora, minuto] = date.substring(date.indexOf('T') + 1, date.length).split(':')
  return `${diaIni}/${mesIni}/${anoIni} ${hora}:${minuto}`
}

export function formatDateTimeWithSeconds(date) {
  if (date === null) return
  if (date.length === 0) return
  const [anoIni, mesIni, diaIni] = date.split('T')[0].split('-')
  const [hora, minuto] = date.substring(date.indexOf('T') + 1, date.length).split(':')
  const segundo = date
    .substring(date.indexOf('T') + 1, date.length)
    .split(':')[2]
    .split('.')[0]
  return `${diaIni}/${mesIni}/${anoIni} ${hora}:${minuto}:${segundo}`
}

export function parseDate(date) {
  if (!date) return null
  const [day, month, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export function formatBytes(a, b = 2) {
  if (0 === a) return '0 Bytes'
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024))
  return (
    parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
    ' ' +
    ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d]
  )
}

export function formatNumber(value) {
  if (value === null || value === undefined) return
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2
  })
}

export function formatNumberPercentual(value) {
  if (value === null || value === undefined) return
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: 3
  })
}

export function formatNumberInteger(value) {
  if (value === null || value === undefined) return 0
  return parseInt(value, 10)
}

export function formataMotivoLixo(motivoLixo) {
  switch (motivoLixo) {
    case 'FALTA_CODIGO_BARRA':
      return 'Falta Código de Barra'

    case 'MATERIAL_NAO_INFORMADO':
      return 'Material não informado'

    case 'NAO_PRODUTO':
      return 'Não Produto'

    case 'USO_CONSUMO':
      return 'Uso Consumo'

    case 'CONFERIR_MAIS_TARDE':
      return 'Conferir mais tarde'

    case 'CODIGO_BARRA_PERTENCE_OUTRO_PRODUTO':
      return 'Código de Barra pertence a outro produto'

    case 'CRIAR_REGRA':
      return 'Criar regra'

    default:
      break
  }
}
